import { render, staticRenderFns } from "./SuggestionBoxItem.vue?vue&type=template&id=26dfe3da&"
import script from "./SuggestionBoxItem.vue?vue&type=script&lang=js&"
export * from "./SuggestionBoxItem.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionBoxItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/timefly-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26dfe3da')) {
      api.createRecord('26dfe3da', component.options)
    } else {
      api.reload('26dfe3da', component.options)
    }
    module.hot.accept("./SuggestionBoxItem.vue?vue&type=template&id=26dfe3da&", function () {
      api.rerender('26dfe3da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SuggestionBoxItem.vue"
export default component.exports